import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button, Popover, OverlayTrigger, Form, Alert } from 'react-bootstrap';
import { useLocation, useParams, Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './ArticleDetail.css';
import config from "../../config";  
import { getItemById, getItemList, getItemByOldTitle, getItemImagesByItemId, getItemLangByItemId, getItemListSize, getItemPublicPDFByIdApi, getItemPublicWORDByIdApi, postCommentItem, putUpdateItem, putUpdateItemViewCount, getAdvancedSearch } from "../../api";
import { getAuthorEntriesFromItem } from '../../utils/authorContributors';
import { useLanguage } from '../../i18n/LanguageContext';
import { getLocalizedArticleDetail, getLocalizedImageCaption } from '../../utils/itemLocaleDisplay';
import { toAbsoluteShareUrl } from '../../utils/socialMeta';
import { stripCmsInlineTypography } from '../../utils/normalizeCmsArticleHtml';

const READING_STORAGE_KEY = 'articleDetailReadingPrefs';
/** Eski kayıtlarda arka plan yanlışlıkla beyazdı; schema yoksa bir kez kreme sıfırlanır */
const READING_PREFS_SCHEMA = 2;
const READING_FONT_MIN = 14;
const READING_FONT_MAX = 28;
/** Sayfa kremi (sol swatch); varsayılan seçili renk */
const READING_BG_PAGE = '#fdfaec';
const READING_BG_WHITE = '#ffffff';

function getInitialReadingPrefs() {
    const defaults = {
        panelOpen: true,
        fontSize: 18,
        align: 'justify',
        background: READING_BG_PAGE
    };
    if (typeof window === 'undefined') return defaults;
    try {
        const raw = localStorage.getItem(READING_STORAGE_KEY);
        if (!raw) return defaults;
        const p = JSON.parse(raw);
        if (!p || typeof p !== 'object') return defaults;
        const schemaOk = p.schema === READING_PREFS_SCHEMA;
        const savedBg = typeof p.background === 'string' ? p.background.trim().toLowerCase() : '';
        let background = READING_BG_PAGE;
        if (schemaOk) {
            if (savedBg === READING_BG_WHITE.toLowerCase()) background = READING_BG_WHITE;
            else if (savedBg === READING_BG_PAGE.toLowerCase()) background = READING_BG_PAGE;
        }
        return {
            panelOpen: typeof p.panelOpen === 'boolean' ? p.panelOpen : defaults.panelOpen,
            /* Her makale açılışında standart 18px; A+/A- yalnızca oturum içi. */
            fontSize: defaults.fontSize,
            align: p.align === 'left' || p.align === 'justify' ? p.align : defaults.align,
            background
        };
    } catch {
        return defaults;
    }
}

const ArticleDetail = () => {
    const [showInfo, setShowInfo] = useState(false);
    const [showQuote, setShowQuote] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [imageScale, setImageScale] = useState(1);
    const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const [isPdfDownloading, setIsPdfDownloading] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [keywordSearchLoading, setKeywordSearchLoading] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const { locale, t } = useLanguage();

    const [item, setItem] = useState({});
    const [relationItemLoading, setRelationItemLoading] = useState(false);
    const [relationItemList, setRelationItemList] = useState([]);
    const [relationStatus, setRelationStatus] = useState(false);
    const [imageList, setImageList] = useState([]);
    const [langItemList, setLangItemList] = useState([]);
    const [langList, setLangList] = useState([]);


    const [customizerStatus, setCustomizerStatus] = useState(() => getInitialReadingPrefs().panelOpen);
    const [customSelectedAlign, setCustomSelectedAlign] = useState(() => getInitialReadingPrefs().align);
    const [customFontSize, setCustomFontSize] = useState(() => getInitialReadingPrefs().fontSize);
    const [customBackgroundColor, setCustomBackgroundColor] = useState(() => getInitialReadingPrefs().background);
    const localizedArticle = useMemo(
      () => getLocalizedArticleDetail(item, locale, langItemList),
      [item, locale, langItemList]
    );
    const displayItemText = useMemo(
      () => stripCmsInlineTypography(localizedArticle.itemText),
      [localizedArticle.itemText]
    );
    const displaySourceText = useMemo(
      () => stripCmsInlineTypography(localizedArticle.sourceText),
      [localizedArticle.sourceText]
    );
    const selectedImageCaption = getLocalizedImageCaption(selectedImage, locale);

    const params = useParams()
    const {id,oldTitle} = params; 
    const getAPI = async () => {
        //console.log('params ', params )
     
        const res = id !== undefined ? await getItemById(id) : await getItemByOldTitle(oldTitle);
        // console.log('res ', res )
        if (res.status) {
            setItem(res.data);
            const tempItem = res.data;
            setRelationItemLoading(true);
            setRelationStatus(tempItem.relationItems !== "")
            const res3 = await getItemImagesByItemId(tempItem.id);
            // console.log('res3 ', res3 )
            if (res3.status)
                setImageList(res3.data);

            //console.log('tempItem', tempItem)
            if (tempItem.relationItems === "") {
                setRelationItemLoading(true);
                const res1 = await getItemListSize(8);
                setRelationItemList(res1.data);
                setRelationItemLoading(false);
                setRelationStatus(false)
            }
            else {
                setRelationItemList(JSON.parse(tempItem.relationItems));
                setRelationStatus(true)
                setRelationItemLoading(false);
            }

            if (tempItem.lang !== "" && tempItem.isMultiLang === 1) {

                const res1 = await getItemLangByItemId(tempItem.id);


                if (tempItem.lang === "Türkçe") {
                    setLangList(["Türkçe", ...res1.data.map(x => x.lang)]);
                    setLangItemList([{ lang: "Türkçe", langItemText: tempItem.itemText }, ...res1.data])
                } else {
                    let tr = res1.data.find(x => x.lang === "Türkçe");
                    setLangList(["Türkçe", tempItem.lang, ...res1.data.filter(x => x.lang !== "Türkçe").map(x => x.lang)]);
                    setLangItemList([tr, { lang: tempItem.lang, langItemText: tempItem.itemText }, ...res1.data.filter(x => x.lang !== "Türkçe")])
                }

                // setLangItemList(tlist);
            }
            if(tempItem)
                {
                  await updateViewCountApi(tempItem) 
                }
             
        }



      
      


    }
    const updateViewCountApi = async (tempItem)=>{
        await putUpdateItemViewCount({id:tempItem.id , viewCount : tempItem.viewCount})
      }

    const handleKeywordClick = async (keywordText) => {
        const trimmed = keywordText.trim();
        if (!trimmed) return;
        try {
            setKeywordSearchLoading(trimmed);
            const response = await getAdvancedSearch({ keyword: trimmed });
            const results = response?.data ?? response ?? [];
            navigate(`/aramaSonuclari?keywords=${encodeURIComponent(trimmed)}&advanced=true`, {
                state: { searchResults: results, searchParams: { keywords: trimmed } }
            });
        } catch (err) {
            console.error('Anahtar kelime araması hatası:', err);
            alert('Arama yapılırken bir hata oluştu.');
        } finally {
            setKeywordSearchLoading(null);
        }
    };

    const onClickDownload = async(type,lang="tr")=>{
        const selectedLang = { id:1 , langTitle:"Türkçe" }
        if(type==="PDF")
        {
            try {
                setIsPdfDownloading(true);
                const pdfFile = await getItemPublicPDFByIdApi(item.id , lang,selectedLang.id);
          
                const fileUrl = URL.createObjectURL(pdfFile);
                //console.log("item ",item)
                
                 let a = document.createElement('a');
                      a.href = fileUrl;
                      a.target="_blank";
                      a.download =  (lang === "tr" ?  item.title : selectedLang.langTitle) +'.pdf';
                      a.click();
            } catch (error) {
                console.error('PDF indirme hatası:', error);
                alert('PDF indirilirken bir hata oluştu.');
            } finally {
                setIsPdfDownloading(false);
            }
        }
    };

   
    const getDateLocale = (date) => {
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        return new Date(date).toLocaleDateString("tr-TR", options);
    };
    useEffect(() => {
        //console.log('id ', id )
        if (id !== undefined)
            getAPI();
    }, [id])

    useEffect(() => {
        //console.log('oldTitle ', oldTitle )
        if (oldTitle !== undefined)
            getAPI();
    }, [oldTitle])

    useEffect(() => {
        try {
            localStorage.setItem(
                READING_STORAGE_KEY,
                JSON.stringify({
                    panelOpen: customizerStatus,
                    align: customSelectedAlign,
                    background: customBackgroundColor,
                    schema: READING_PREFS_SCHEMA
                })
            );
        } catch (_) { /* ignore */ }
    }, [customizerStatus, customSelectedAlign, customBackgroundColor]);

    const adjustReadingFontSize = (delta) => {
        setCustomFontSize(prev => Math.min(READING_FONT_MAX, Math.max(READING_FONT_MIN, prev + delta)));
    };

        const handlePrint = () => {
        // Direkt yazdırma ekranını aç
        window.print();
    };

    // Image modal fonksiyonları
    const handleImageClick = (image, index) => {
        setSelectedImage(image);
        setCurrentImageIndex(index);
        setShowImageModal(true);
    };

    const handleCloseImageModal = () => {
        setShowImageModal(false);
        setSelectedImage(null);
        setCurrentImageIndex(0);
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    // Zoom fonksiyonları
    const handleZoomIn = () => {
        setImageScale(prev => Math.min(prev * 1.2, 5)); // Max 5x zoom
    };

    const handleZoomOut = () => {
        setImageScale(prev => Math.max(prev / 1.2, 0.5)); // Min 0.5x zoom
    };

    const handleZoomReset = () => {
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    const handleImageDoubleClick = () => {
        if (imageScale === 1) {
            setImageScale(2);
        } else {
            handleZoomReset();
        }
    };

    // Mouse wheel zoom
    const handleWheel = (e) => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? 0.9 : 1.1;
        setImageScale(prev => Math.min(Math.max(prev * delta, 0.5), 5));
    };

    // Drag fonksiyonları (zoom'lanmış resmi kaydırma için)
    const handleMouseDown = (e) => {
        if (imageScale > 1) {
            setIsDragging(true);
            setDragStart({
                x: e.clientX - imagePosition.x,
                y: e.clientY - imagePosition.y
            });
        }
    };

    const handleMouseMove = (e) => {
        if (isDragging && imageScale > 1) {
            setImagePosition({
                x: e.clientX - dragStart.x,
                y: e.clientY - dragStart.y
            });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const goToPreviousImage = () => {
        const newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : imageList.length - 1;
        setCurrentImageIndex(newIndex);
        setSelectedImage(imageList[newIndex]);
        // Reset zoom when changing images
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    const goToNextImage = () => {
        const newIndex = currentImageIndex < imageList.length - 1 ? currentImageIndex + 1 : 0;
        setCurrentImageIndex(newIndex);
        setSelectedImage(imageList[newIndex]);
        // Reset zoom when changing images
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    // Keyboard navigation için
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (showImageModal) {
                switch (event.key) {
                    case 'Escape':
                        handleCloseImageModal();
                        break;
                    case 'ArrowLeft':
                        goToPreviousImage();
                        break;
                    case 'ArrowRight':
                        goToNextImage();
                        break;
                    case '+':
                    case '=':
                        handleZoomIn();
                        break;
                    case '-':
                        handleZoomOut();
                        break;
                    case '0':
                        handleZoomReset();
                        break;
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [showImageModal, currentImageIndex]);

    const getTitleSlug = (title) => {
      if (!title || typeof title !== 'string') return '';
      const trMap = {
        'ı': 'i', 'İ': 'i', 'I': 'i',
        'ğ': 'g', 'Ğ': 'g',
        'ü': 'u', 'Ü': 'u',
        'ş': 's', 'Ş': 's',
        'ö': 'o', 'Ö': 'o',
        'ç': 'c', 'Ç': 'c'
      };
      const slug = title
        .split('')
        .map(c => trMap[c] ?? c)
        .join('')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
      return slug || 'baslik';
    };

    const getItemUrl = (item) => {
      const slug = getTitleSlug(item.title);
      return `${window.location.origin}/article/${item.id}${slug ? `/${slug}` : ''}`;
    };

      const citation = `${item.writerName} (2024). "${localizedArticle.title}", Akademik Kaynak, Cilt 1, Sayı 1, s. 1-15.`;

    // Geri Bildirim Modalı
    const FeedbackModal = (props) => {
      const {item} = props;

      const [nameSurname, setNameSurname] = useState("");
      const [mail, setMail] = useState("");
      const [comment, setComment] = useState("");
      const [phone, setPhone] = useState("");
      const [captchaData, setCaptchaData] = useState({ text: '', answer: '' });
      const [captchaAttempts, setCaptchaAttempts] = useState(0);
      const [isBlocked, setIsBlocked] = useState(false);
      const [blockUntil, setBlockUntil] = useState(0);
      const [lastSubmission, setLastSubmission] = useState(0);
      const [userCaptchaInput, setUserCaptchaInput] = useState("");

      // Gelişmiş matematik captcha oluştur
      const generateAdvancedCaptcha = () => {
        // Daha karmaşık matematik işlemleri
        const operations = [
          { op: '+', fn: (a, b) => a + b, maxA: 50, maxB: 30 },
          { op: '-', fn: (a, b) => a - b, maxA: 50, maxB: 30 },
          { op: '×', fn: (a, b) => a * b, maxA: 12, maxB: 8 },
          { op: '÷', fn: (a, b) => a * b, maxA: 12, maxB: 8 } // Bölme için çarpım kullan
        ];
        
        const operation = operations[Math.floor(Math.random() * operations.length)];
        const a = Math.floor(Math.random() * operation.maxA) + 1;
        const b = Math.floor(Math.random() * operation.maxB) + 1;
        
        let question, answer;
        
        if (operation.op === '÷') {
          // Bölme için: a × b ÷ b = a
          question = `${a * b} ÷ ${b} = ?`;
          answer = a.toString();
        } else {
          question = `${a} ${operation.op} ${b} = ?`;
          answer = operation.fn(a, b).toString();
        }
        
        return { text: question, answer };
      };

      const validateCaptcha = (input) => {
        // Blok kontrolü
        if (isBlocked && Date.now() < blockUntil) {
          const remainingTime = Math.ceil((blockUntil - Date.now()) / 1000);
          alert(`Çok fazla deneme! ${remainingTime} saniye bekleyin.`);
          return false;
        }
        
        // Rate limiting
        const now = Date.now();
        if (now - lastSubmission < 30000) { // 30 saniye
          alert("Çok hızlı gönderim! 30 saniye bekleyin.");
          return false;
        }
        
        // Captcha doğrulama
        if (input.trim() !== captchaData.answer) {
          setCaptchaAttempts(prev => prev + 1);
          
          if (captchaAttempts >= 2) { // 3 deneme hakkı
            setIsBlocked(true);
            setBlockUntil(now + 300000); // 5 dakika blok
            setCaptchaAttempts(0);
            alert("Çok fazla hatalı deneme! 5 dakika bekleyin.");
          } else {
            alert(`Yanlış cevap! ${2 - captchaAttempts} deneme hakkınız kaldı.`);
          }
          return false;
        }
        
        // Başarılı
        setCaptchaAttempts(0);
        return true;
      };

      // Modal açıldığında captcha oluştur
      useEffect(() => {
        if (props.show) {
          setCaptchaData(generateAdvancedCaptcha());
          setUserCaptchaInput("");
          setIsBlocked(false);
          setCaptchaAttempts(0);
          setBlockUntil(0);
        }
      }, [props.show]);

      // Blok süresini kontrol et
      useEffect(() => {
        if (isBlocked && Date.now() >= blockUntil) {
          setIsBlocked(false);
          setBlockUntil(0);
        }
      }, [isBlocked, blockUntil]);

      const saveComment = async()=>{
        if (!validateCaptcha(userCaptchaInput)) {
          return;
        }
        
        // Başarılı gönderim
        setLastSubmission(Date.now());
        
        const data = { 
          nameSurname,
          mail,
          phone,
          comment,
          itemId : item.id
        }

        if(nameSurname.length>0 && mail.length>0 && comment.length>1)
        {
          const res = await postCommentItem(data);
          if(res.status)
          {
            alert("Mesaj gönderme başarılı");
            // Form alanlarını temizle
            setNameSurname("");
            setMail("");
            setPhone("");
            setComment("");
            // Yeni captcha oluştur
            setCaptchaData(generateAdvancedCaptcha());
            setUserCaptchaInput("");
            props.onHide();
          }
        }
        else
        {
          alert("Mesaj Gönderme başarısız" )
        }
      }

      return (
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {config.project.name} Madde Mesaj Formu
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert variant="warning" className="mb-3">
              Bu formun yalnızca <strong>{localizedArticle.title}</strong> 
              maddesi ile ilgili mesajlar için kullanılması, Türk Mutfak Kültürü Atlası ve Ansiklopedisi'ne ilişkin diğer hususların 
              <a href="/iletisim"> İletişim Formu</a> üzerinden iletilmesi rica
              olunur.
            </Alert>

            <Form method="POST">
              <Form.Group className="mb-3">
                <Form.Label>Mesajınız*</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Ayrıntılı olarak mesajınızı yazınız."
                  rows={2}
                  onChange={e=>setComment(e.target.value)}
                  value={comment}
                />
              </Form.Group>
              
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Ad Soyad*</Form.Label>
                    <Form.Control 
                      type="text"  
                      onChange={e=>setNameSurname(e.target.value)} 
                      value={nameSurname} 
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>E-posta*</Form.Label>
                    <Form.Control 
                      type="email" 
                      onChange={e=>setMail(e.target.value)}  
                      value={mail} 
                      placeholder="isim@ornek.com" 
                    />
                  </Form.Group>
                </div>
              </div>

              <Form.Group className="mb-3">
                <Form.Label>Telefon</Form.Label>
                <Form.Control 
                  type="number" 
                  onChange={e=>setPhone(e.target.value)}  
                  value={phone} 
                  placeholder="05XXXXXXXXX" 
                />
              </Form.Group>

              <div className="captcha-container">
                <div className="captcha-box">
                  <span>Doğrulama: </span>
                  <span className="captcha-question">{captchaData.text}</span>
                  <button 
                    type="button" 
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setCaptchaData(generateAdvancedCaptcha())}
                    title="Yeni soru oluştur"
                    disabled={isBlocked}
                  >
                    🔄
                  </button>
                  <Form.Control
                    type="text"
                    placeholder="Cevabı girin"
                    value={userCaptchaInput}
                    onChange={(e) => setUserCaptchaInput(e.target.value)}
                    style={{ width: '150px' }}
                    disabled={isBlocked}
                  />
                </div>
                {isBlocked && (
                  <div className="captcha-blocked">
                    <small className="text-danger">
                      Çok fazla hatalı deneme! {Math.ceil((blockUntil - Date.now()) / 1000)} saniye bekleyin.
                    </small>
                  </div>
                )}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={props.onHide} variant="secondary">
              {t('articleDetail.modalClose')}
            </Button>
            <Button 
              onClick={()=>saveComment()} 
              variant="danger" 
              className="text-white"
              disabled={isBlocked}
            >
              Gönder
            </Button>
          </Modal.Footer>
        </Modal>
      );
    };

    const popover = (item) => (
      <Popover id="popover-basic">
        <Popover.Header as="h3">{localizedArticle.title}</Popover.Header>
        <Popover.Body>
          <div className="textarea">
            <p>
              <span>{t('articleDetail.authorLabel')}</span> {item.writerName}
            </p>
            <p>
              <span>Web Sitesi:</span> {config.appUrl}
            </p>
            <p>
              <span>Yayımcı:</span> {config.project.name}
            </p>
            <p>
              <span>Erişim Tarihi:</span> {new Date().toLocaleDateString()}
            </p>
            <p>
              <span>Web Sitesi Adresi:</span>{" "}
              {getItemUrl(item)}
            </p>
          </div>
          <p><b>Kopyalama Metni</b></p>
          <p id="atifCopyText">
            {`${item.writerName}, "${localizedArticle.title}", ${config.project.name},
            ${getItemUrl(item)}
            (${new Date().toLocaleDateString()})`}.
          </p>
        </Popover.Body>
      </Popover>
    );

    const readingTextColor = '#333333';

    const shareOrigin =
      typeof window !== 'undefined' && window.location?.origin
        ? window.location.origin
        : config.publicSiteOrigin;
    const ogImageUrl = toAbsoluteShareUrl(config.defaultOgImagePath, shareOrigin);

    return (
        <>
            {/* SEO Meta Tags */}
            <Helmet>
                <title>{localizedArticle.title ? `${localizedArticle.title} - ${config.project.name}` : config.project.name}</title>
                <meta name="description" content={localizedArticle.definition || localizedArticle.title} />
                {localizedArticle.keyword && (
                    <meta name="keywords" content={localizedArticle.keyword} />
                )}
                <meta property="og:title" content={localizedArticle.title} />
                <meta property="og:description" content={localizedArticle.definition || localizedArticle.title} />
                <meta property="og:type" content="article" />
                <meta property="og:url" content={getItemUrl(item)} />
                <meta property="og:image" content={ogImageUrl} />
                <meta property="og:image:secure_url" content={ogImageUrl} />
                <meta property="og:image:alt" content={config.project.name} />
                <meta property="article:author" content={item.writerName} />
                {localizedArticle.keyword && (
                    <meta property="article:tag" content={localizedArticle.keyword} />
                )}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={localizedArticle.title} />
                <meta name="twitter:description" content={localizedArticle.definition || localizedArticle.title} />
                <meta name="twitter:image" content={ogImageUrl} />
                
                {/* Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Article",
                        "headline": localizedArticle.title,
                        "description": localizedArticle.definition,
                        "image": ogImageUrl,
                        "author": {
                            "@type": "Person",
                            "name": item.writerName
                        },
                        "publisher": {
                            "@type": "Organization",
                            "name": config.project.name,
                            "url": config.appUrl
                        },
                        "datePublished": new Date().toISOString(),
                        "dateModified": new Date().toISOString(),
                        "mainEntityOfPage": {
                            "@type": "WebPage",
                            "@id": getItemUrl(item)
                        },
                        "keywords": localizedArticle.keyword ? localizedArticle.keyword.split(',').map(k => k.trim()) : [],
                        "url": getItemUrl(item)
                    })}
                </script>
            </Helmet>
            
            <div className="article-detail-container">
            <div className="article-detail-grid">
                <div className="article-content-detail-column article-reading-layout">
                    {customizerStatus && (
                        <aside className="article-reading-customizer" aria-label="Okuma ayarları">
                           
                            <div className="article-reading-customizer__section">
                                <button
                                    type="button"
                                    className="article-reading-customizer__font-btn"
                                    onClick={() => adjustReadingFontSize(-1)}
                                    disabled={customFontSize <= READING_FONT_MIN}
                                    title="Metin boyutunu küçült"
                                    aria-label="Metin boyutunu küçült"
                                >
                                    <span className="article-reading-customizer__font-pair">
                                        <span className="article-reading-customizer__font-letter">A</span>
                                        <svg className="article-reading-customizer__font-tri" viewBox="0 0 14 9" width="14" height="9" aria-hidden="true" focusable="false">
                                            <path fill="currentColor" d="M0 0h14L7 9z" />
                                        </svg>
                                    </span>
                                </button>
                                <button
                                    type="button"
                                    className="article-reading-customizer__font-btn"
                                    onClick={() => adjustReadingFontSize(1)}
                                    disabled={customFontSize >= READING_FONT_MAX}
                                    title="Metin boyutunu büyüt"
                                    aria-label="Metin boyutunu büyüt"
                                >
                                    <span className="article-reading-customizer__font-pair">
                                        <span className="article-reading-customizer__font-letter">A</span>
                                        <svg className="article-reading-customizer__font-tri" viewBox="0 0 14 9" width="14" height="9" aria-hidden="true" focusable="false">
                                            <path fill="currentColor" d="M7 0L14 9H0z" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                            <div className="article-reading-customizer__section">
                                <button
                                    type="button"
                                    className={`article-reading-customizer__swatch ${customBackgroundColor.toLowerCase() === READING_BG_PAGE.toLowerCase() ? 'is-active' : ''}`}
                                    style={{ backgroundColor: READING_BG_PAGE }}
                                    onClick={() => setCustomBackgroundColor(READING_BG_PAGE)}
                                    title="Sayfa ile aynı krem arka plan"
                                    aria-label="Sayfa ile aynı krem arka plan"
                                />
                                <button
                                    type="button"
                                    className={`article-reading-customizer__swatch ${customBackgroundColor.toLowerCase() === READING_BG_WHITE.toLowerCase() ? 'is-active' : ''}`}
                                    style={{ backgroundColor: READING_BG_WHITE }}
                                    onClick={() => setCustomBackgroundColor(READING_BG_WHITE)}
                                    title="Beyaz arka plan"
                                    aria-label="Beyaz arka plan"
                                />
                            </div>
                            <div className="article-reading-customizer__section article-reading-customizer__section--last">
                                <button
                                    type="button"
                                    className="article-reading-customizer__close"
                                    onClick={() => setCustomizerStatus(false)}
                                >
                                    {t('articleDetail.readingCustomizerClose')}
                                </button>
                            </div>
                        </aside>
                    )}
                    {!customizerStatus && (
                        <button
                            type="button"
                            className="article-reading-customizer__reopen"
                            onClick={() => setCustomizerStatus(true)}
                            title="Okuma ayarlarını aç"
                            aria-label="Okuma ayarlarını aç"
                        >
                            Aa
                        </button>
                    )}
                    <div
                        className="article-reading-zone"
                        style={{
                            backgroundColor: customBackgroundColor,
                            color: readingTextColor,
                            fontSize: `${customFontSize}px`
                        }}
                    >
                    <div className="article-detail-header">
                        <h1 className="article-detail-title">{localizedArticle.title}</h1>
                        {localizedArticle.definition ? (
                            <p className="article-detail-subtitle">{localizedArticle.definition}</p>
                        ) : null}
                    </div>

                    <div className="article-detail-meta-bar">
                        <div className="article-detail-meta-bar__authors">
                            <span className="article-detail-author-label">{t('articleDetail.authorLabel')}</span>
                            <div className="author-detail-frame">
                                {getAuthorEntriesFromItem(item).map((author, idx) => (
                                    <React.Fragment key={`${author.userId ?? 'noid'}-${idx}`}>
                                        {idx > 0 && (
                                            <span className="article-author-sep">
                                                ,{'\u00a0'}
                                            </span>
                                        )}
                                        {author.userId ? (
                                            <Link
                                                to={`/yazar/${author.userId}`}
                                                style={{ textDecoration: 'none', color: 'inherit' }}
                                            >
                                                <span className="article-author-detail-name">{author.name}</span>
                                            </Link>
                                        ) : (
                                            <span className="article-author-detail-name">{author.name}</span>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                        <div className="article-detail-meta-bar__actions" role="toolbar" aria-label="Madde araçları">
                            <div className="article-detail-meta-bar__cell">
                                <div
                                    className={`pdf-download-button ${isPdfDownloading ? 'downloading' : ''}`}
                                    onClick={() => !isPdfDownloading && onClickDownload("PDF", "tr")}
                                    title={isPdfDownloading ? "PDF indiriliyor..." : "Bu maddeyi PDF olarak indir"}
                                >
                                    {isPdfDownloading ? (
                                        <svg className="action-icon pdf-loading-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <circle cx="12" cy="12" r="3" opacity="0.1" />
                                            <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25" />
                                            <path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z">
                                                <animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" />
                                            </path>
                                        </svg>
                                    ) : (
                                        <svg className="action-icon pdf-download-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M14,2H6A2,2 0,0,0,4,4V20A2,2,0,0,0,6,22H18A2,2,0,0,0,20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                                            <text x="12" y="17" textAnchor="middle" fontSize="7" fill="currentColor" fontWeight="bold">PDF</text>
                                        </svg>
                                    )}
                                </div>
                            </div>
                            <div className="article-detail-meta-bar__cell">
                                <svg
                                    className="action-icon"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    onClick={handlePrint}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => e.key === 'Enter' && handlePrint()}
                                    aria-label="Bu maddeyi yazdır"
                                    title="Bu maddeyi yazdır"
                                >
                                    <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 3H7v-1h9v1zm3-2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
                                </svg>
                            </div>
                            <div className="article-detail-meta-bar__cell">
                                <svg
                                    className="action-icon"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    onClick={() => setShowInfo(true)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => e.key === 'Enter' && setShowInfo(true)}
                                    aria-label="Madde künyesi bilgilerini görüntüle"
                                    title="Madde künyesi bilgilerini görüntüle"
                                >
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                                </svg>
                            </div>
                            <div className="article-detail-meta-bar__cell">
                                <OverlayTrigger trigger="click" placement="left" overlay={popover(item)} rootClose>
                                    <svg
                                        className="action-icon"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        title="Alıntılama bilgilerini görüntüle"
                                        aria-label="Alıntılama bilgilerini görüntüle"
                                    >
                                        <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
                                    </svg>
                                </OverlayTrigger>
                            </div>
                            <div className="article-detail-meta-bar__cell">
                                <div
                                    className="feedback-button"
                                    onClick={() => setModalShow(true)}
                                    title="Bu madde hakkında bildirimde bulunun"
                                >
                                    <svg className="action-icon feedback-icon" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M20,4H4C2.9,4,2,4.9,2,6V18C2,19.1,2.9,20,4,20H20C21.1,20,22,19.1,22,18V6C22,4.9,21.1,4,20,4M20,8L12,13L4,8V6L12,11L20,6V8Z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div 
                      className="article-detail-text pt-2"
                      style={{ textAlign: customSelectedAlign }}
                      dangerouslySetInnerHTML={{ __html: displayItemText }}
                    />

                    {/* Anahtar Kelimeler Bölümü */}
                    {localizedArticle.keyword && (
                        <div className="article-detail-keywords pt-3 mt-3">
                            <h3 className="keywords-title">{t('articleDetail.keywordsTitle')}</h3>
                            <div className="keywords-content">
                                {localizedArticle.keyword.split(',').map((keyword, index) => {
                                    const kw = keyword.trim();
                                    const isLoading = keywordSearchLoading === kw;
                                    return (
                                        <button
                                            key={index}
                                            type="button"
                                            className="keyword-tag keyword-tag-clickable"
                                            onClick={() => handleKeywordClick(kw)}
                                            disabled={!!keywordSearchLoading}
                                            title={`"${kw}" ile ara`}
                                            itemProp="keywords"
                                        >
                                            {isLoading ? '...' : kw}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* Kaynakça Bölümü */}
                    {localizedArticle.sourceText && (
                        <div className="article-detail-sources pt-3 mt-3">
                            <h3 className="sources-title">{t('articleDetail.bibliography')}</h3>
                            <div 
                                className="sources-content"
                                style={{ textAlign: customSelectedAlign }}
                                dangerouslySetInnerHTML={{ __html: displaySourceText }}
                            />
                        </div>
                    )}
                    <div className="article-detail-view-count">
                        <p>
                            <svg className="view-count-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                            </svg>
                            Görüntülenme Sayısı: {item.viewCount}
                        </p>
                    </div>
                    </div>
                </div>

                <div className="article-detail-images-column">
                    {imageList.map((image, index) => {
                        const caption = getLocalizedImageCaption(image, locale);
                        return (
                        <figure key={index} className="article-detail-figure">
                            <img 
                                src={image.url} 
                                alt={caption}
                                onClick={() => handleImageClick(image, index)}
                                style={{ cursor: 'pointer' }}
                            />
                            <figcaption>{caption}</figcaption>
                        </figure>
                        );
                    })}
                </div>
            </div>

            {/* Info Modal */}
            <Modal show={showInfo} onHide={() => setShowInfo(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Madde Künyesi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="article-info">
                        <p><strong>{t('articleDetail.authorLabel')}</strong> {item.writerName}</p>
                        <p><strong>Başlık:</strong> {localizedArticle.title}</p>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Quote Modal */}
            <Modal show={showQuote} onHide={() => setShowQuote(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Alıntılama Formatı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="citation-info">
                        <p className="mb-3">Bu makaleyi alıntılamak için:</p>
                        <div className="citation-text p-3 bg-light">
                            {`${item.writerName} (2024). "${localizedArticle.title}", Akademik Kaynak, Cilt 1, Sayı 1, s. 1-15.`}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => navigator.clipboard.writeText(citation)}>
                        Kopyala
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Image Modal */}
            <Modal 
                show={showImageModal} 
                onHide={handleCloseImageModal} 
                centered 
                size="xl"
                className="image-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedImageCaption}
                        {imageList.length > 1 && (
                            <small className="ms-2">({currentImageIndex + 1} / {imageList.length})</small>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body 
                    className="text-center p-0 position-relative"
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseUp}
                    onWheel={handleWheel}
                    style={{ overflow: 'hidden', cursor: isDragging ? 'grabbing' : (imageScale > 1 ? 'grab' : 'default') }}
                >
                    {selectedImage && (
                        <>
                            <img 
                                src={selectedImage.url} 
                                alt={selectedImageCaption}
                                onDoubleClick={handleImageDoubleClick}
                                onMouseDown={handleMouseDown}
                                style={{
                                    maxWidth: imageScale === 1 ? '100%' : `${100 * imageScale}%`,
                                    maxHeight: imageScale === 1 ? '100%' : `${100 * imageScale}%`,
                                    width: imageScale === 1 ? 'auto' : 'auto',
                                    height: imageScale === 1 ? 'auto' : 'auto',
                                    objectFit: 'contain',
                                    transform: `scale(${imageScale}) translate(${imagePosition.x}px, ${imagePosition.y}px)`,
                                    transition: isDragging ? 'none' : 'transform 0.2s ease',
                                    cursor: imageScale > 1 ? 'grab' : 'zoom-in',
                                    userSelect: 'none',
                                    pointerEvents: 'auto'
                                }}
                                draggable={false}
                            />
                            
                            {/* Navigation buttons */}
                            {imageList.length > 1 && (
                                <>
                                    <button
                                        onClick={goToPreviousImage}
                                        className="image-nav-btn image-nav-prev"
                                        aria-label={t('articleDetail.imageAriaPrev')}
                                    >
                                        &#8249;
                                    </button>
                                    <button
                                        onClick={goToNextImage}
                                        className="image-nav-btn image-nav-next"
                                        aria-label={t('articleDetail.imageAriaNext')}
                                    >
                                        &#8250;
                                    </button>
                                </>
                            )}
                            
                            {/* Zoom controls */}
                            <div className="zoom-controls">
                                <button
                                    onClick={handleZoomOut}
                                    className="zoom-btn zoom-out"
                                    disabled={imageScale <= 0.5}
                                    aria-label={t('articleDetail.imageAriaZoomOut')}
                                >
                                    −
                                </button>
                                <span className="zoom-level">{Math.round(imageScale * 100)}%</span>
                                <button
                                    onClick={handleZoomIn}
                                    className="zoom-btn zoom-in"
                                    disabled={imageScale >= 5}
                                    aria-label={t('articleDetail.imageAriaZoomIn')}
                                >
                                    +
                                </button>
                                <button
                                    onClick={handleZoomReset}
                                    className="zoom-btn zoom-reset"
                                    disabled={imageScale === 1 && imagePosition.x === 0 && imagePosition.y === 0}
                                    aria-label={t('articleDetail.imageAriaReset')}
                                >
                                    ⌂
                                </button>
                            </div>
                        </>
                    )}
                </Modal.Body>
                {selectedImageCaption && (
                    <Modal.Footer className="justify-content-center">
                        <small className="text-muted">{selectedImageCaption}</small>
                        <div className="d-flex flex-wrap justify-content-center gap-3 mt-2">
                            {imageList.length > 1 && (
                                <small className="text-muted">
                                    {t('articleDetail.imageModalNavKeys')}
                                </small>
                            )}
                            <small className="text-muted">
                                {t('articleDetail.imageModalZoomHelp')}
                            </small>
                            <small className="text-muted">
                                {t('articleDetail.imageModalPanHelp')}
                            </small>
                        </div>
                    </Modal.Footer>
                )}
            </Modal>

            {/* Geri Bildirim Modalı */}
            <FeedbackModal
              show={modalShow}
              onHide={() => setModalShow(false)}
              item={item}
            />
        </div>
        </>
    );
};

export default ArticleDetail; 